export interface AppState {
  isSyncing?: boolean;
  isLoading: boolean;
  error: string;
}
